import React, { useEffect, useState } from "react";
import ReactSelect, { components } from "react-select";
import { get } from "../Libraries/Ajax/HttpService";
import { useDistrict } from "../utils/DistrictContext";

const Option = (props) => (
  <components.Option {...props}>
    <label>{props.label}</label>
  </components.Option>
);

function ExamplesWithDistrict({ parentCallback }) {
  const districtContext = useDistrict();
  const selectedDistrict =
    typeof districtContext === "string"
      ? districtContext
      : districtContext?.selectedDistrict || "";

  const [items, setItems] = useState([]);
  const [optionSelected, setOptionSelected] = useState([]);

  /** ---------------------------------------
   *  LOAD ACCOUNTS WHEN COMPONENT MOUNTS OR DISTRICT CHANGES
   *  --------------------------------------- */
  useEffect(() => {
    loadAccounts();
  }, [selectedDistrict]);

  /** ---------------------------------------
   *  API: Load Account List + Default Selection
   *  --------------------------------------- */
  const loadAccounts = async () => {
    try {
      const response = await get(
        `apis/account/overide_name/aggregate/select/list`
      );

      const accountList = response?.data?.data?.account_override_list || [];
      const mappedItems = accountList.map(({ overided_name }) => ({
        label: overided_name,
        value: overided_name,
      }));

      const user = JSON.parse(localStorage.getItem("MCData"));

      let defaultSelection = [];

      // Apply your district logic
      if (selectedDistrict !== "FB151" && user?.userid) {
        defaultSelection = [
          { label: "PHMSCM Holdings", value: "PHMSCM Holdings" },
        ];
      } else {
        defaultSelection = mappedItems[0] ? [mappedItems[0]] : [];
      }

      setItems(mappedItems);
      setOptionSelected(defaultSelection);

      // Trigger category API if default exists
      if (defaultSelection.length > 0) {
        handleChange(defaultSelection);
      }
    } catch (error) {
      console.error("Failed to load accounts:", error);
    }
  };

  /** ---------------------------------------
   *  HANDLE CHANGE
   *  --------------------------------------- */
  const handleChange = async (selected) => {
    setOptionSelected(selected);

    const product = selected.map((item) => encodeURIComponent(item.value));

    try {
      const res = await get(
        `apis/category/account_override/select?selected=${JSON.stringify(
          product
        )}`
      );

      const selectedCategories =
        res?.data?.data?.categories?.selected_categories || [];

      if (typeof parentCallback === "function") {
        if (selectedCategories.length === 0) {
          parentCallback(res);
        } else {
          parentCallback(res, product);
        }
      }
    } catch (err) {
      console.error("API request failed:", err);
    }
  };

  /** ---------------------------------------
   *  RENDER
   *  --------------------------------------- */
  if (!items.length) return <div></div>;

  return (
    <span
      className="d-inline-block"
      data-toggle="popover"
      data-trigger="focus"
      data-content="Please select account(s)"
    >
      <ReactSelect
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 99999 }),
        }}
        menuPortalTarget={document.body}
        options={items}
        isMulti
        value={optionSelected}
        onChange={handleChange}
        components={{ Option }}
      />
    </span>
  );
}

export default ExamplesWithDistrict;
